import { PutSimulationBuildingDeleteReq } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

/** 山積対象物件一覧-削除 */
export class DeleteSimulationBuildingGateway {
  static putSimulationBuildingDelete = async (
    params: PutSimulationBuildingDeleteReq
  ) => {
    return await yamadumiApi.put('/api/simulation/building/item', { ...params })
  }
}
